module.exports = __webpack_public_path__ + "img/plugme_r2.01ee0e28.png";